import ReactDOM from 'react-dom';
import { App } from './App';
import './settings';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);